/**
 * Shared section intro: small uppercase eyebrow, headline, optional
 * supporting line. Keeps every landing section typographically in step.
 */
export default function SectionHeading({ eyebrow, title, subtitle }) {
  return (
    <div className="mx-auto max-w-xl text-center">
      <div className="mb-4 text-[12px] uppercase tracking-[0.14em] text-vaulzo-fainter">
        {eyebrow}
      </div>
      <h2 className="text-[28px] font-bold tracking-[-0.02em] text-vaulzo-ink sm:text-[34px]">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-4 text-[16px] leading-relaxed text-vaulzo-muted">{subtitle}</p>
      )}
    </div>
  );
}
